import axios from '@/plugins/axios'

export default {
  fetch(params) {
    return axios.get('attributes', { params }).then(result => result.data)
  },
  reorder(attributeId, values) {
    return axios.post(`attributes/${attributeId}/reorder`, {
      values
    }).then(result => result.data)
  },
  createAttributeValue(attributeId, value) {
    return axios.post(`attributes/${attributeId}`, {
      value
    }).then(result => result.data)
  },
  updateAttributeValue(valueId, value) {
    return axios.patch(`attributes/value/${valueId}`, {
      value
    }).then(result => result.data)
  },
  deleteValue(valueId) {
    return axios.delete(`attributes/value/${valueId}`).then(result => result.data)
  }
}
